/* eslint-disable no-unused-vars, @typescript-eslint/no-unused-vars */
/**
 * Trades table
 */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AutoSizer } from 'react-virtualized';
import MyPositions from './MyPositions';
import PriceAlerts from './PriceAlerts';
import LimitOrders from './LimitOrders';
import TopTraders from './TopTraders';
import Trades from './Trades';
import Text from '../../atoms/Text';
import { getWatchedLimitOrders } from '../../selectors/limitOrders';
import { getWatchedPriceAlerts } from '../../selectors/priceAlerts';

import './styles.scss';

export const getClassNameForRow = (isActive: boolean, isBuying: boolean) => {
  if (isActive) {
    return isBuying ? 'row--green' : 'row--red';
  }
  return '';
};

enum Tab {
  Trades = 'Trades',
  Positions = 'My Trades',
  TopTraders = 'Top traders',
  PriceAlerts = 'Price alerts',
  LimitOrders = 'Limit orders',
  None = 'None',
}

const LIMITED_TABS = [Tab.PriceAlerts, Tab.LimitOrders];

const TABS = [
  Tab.Trades,
  Tab.Positions,
  Tab.TopTraders,
  Tab.PriceAlerts,
  Tab.LimitOrders,
];

const PriceAlertsCounter = () => {
  const watchedAlerts = useSelector(getWatchedPriceAlerts);

  return (
    <div className='dex_trades__options__item__counter_tab'>
      <Text size={10}>{watchedAlerts.length}</Text>
    </div>
  );
};

const LimitOrdersCounter = () => {
  const watchedLimitOrders = useSelector(getWatchedLimitOrders);

  return (
    <div className='dex_trades__options__item__counter_tab'>
      <Text size={10}>{watchedLimitOrders.length}</Text>
    </div>
  );
};

const Tabs = ({ limited, active, onChange }: any) => (
  <div className='dex_trades__options'>
    {(limited ? LIMITED_TABS : TABS).map((key) => (
      <div
        key={key}
        onClick={() => onChange(key)}
        className={`dex_trades__options__item ${
          key === active ? 'dex_trades__options__item--active' : ''
        }`}
      >
        <Text size={12}>{key}</Text>
        {key === Tab.PriceAlerts && <PriceAlertsCounter />}
        {key === Tab.LimitOrders && <LimitOrdersCounter />}
      </div>
    ))}
  </div>
);

interface IDexTradesProps {
  limited: boolean;
}

/**
 * Component for uniswap and its forks
 * @param props
 * @returns
 */
const DexTrades = ({ limited }: IDexTradesProps) => {
  const [tab, setTab] = useState<Tab>(Tab.None);

  useEffect(() => {
    setTab(limited ? Tab.PriceAlerts : Tab.Trades);
  }, [limited]);

  return (
    <div className='dex_trades'>
      <Tabs limited={limited} active={tab} onChange={setTab} />
      <div className='dex_trades__separator' />
      {!limited && tab === Tab.Trades && (
        <AutoSizer style={{ width: '100%', height: '100%' }}>
          {({ width }) => <Trades width={width} />}
        </AutoSizer>
      )}
      {!limited && tab === Tab.Positions && (
        <AutoSizer style={{ width: '100%', height: '100%' }}>
          {({ width }) => <MyPositions width={width} />}
        </AutoSizer>
      )}
      {!limited && tab === Tab.TopTraders && (
        <AutoSizer style={{ width: '100%', height: '100%' }}>
          {({ width }) => <TopTraders width={width} />}
        </AutoSizer>
      )}
      {tab === Tab.PriceAlerts && (
        <AutoSizer style={{ width: '100%', height: '100%' }}>
          {({ width }) => <PriceAlerts width={width} />}
        </AutoSizer>
      )}
      {tab === Tab.LimitOrders && (
        <AutoSizer style={{ width: '100%', height: '100%' }}>
          {({ width }) => <LimitOrders width={width} />}
        </AutoSizer>
      )}
    </div>
  );
};

export default DexTrades;
